import { useLocation, useNavigate } from "react-router-dom";

// Opens a lead's detail page, remembering the pipeline URL it was opened from
// (pipeline, view, list page) so the detail page's Back button returns to exactly
// the same place. Filters are restored separately from localStorage (useLeadData).
export const useOpenLead = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (dealId) =>
    navigate(`/lead-management-system/${dealId}`, {
      state: { from: `${location.pathname}${location.search}` },
    });
};
